import React from 'react';
import { SingleColumnLayout } from './SingleColumnLayout';
import { TwoColumnLayout } from './TwoColumnLayout';
import { SidebarLayout } from './SidebarLayout';
import { CreativeLayout } from './CreativeLayout';

export const layouts = {
  'single-column': SingleColumnLayout,
  'two-column': TwoColumnLayout,
  'sidebar-left': (props) => <SidebarLayout {...props} sidebarPosition="left" />,
  'sidebar-right': (props) => <SidebarLayout {...props} sidebarPosition="right" />,
  'creative': CreativeLayout,
};

export const defaultLayoutId = 'single-column';

export function getLayout(layoutId) {
  return layouts[layoutId] || layouts[defaultLayoutId];
}
